var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighschool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9993 8.48901L11.3223 14.118H14.7153L12.9993 8.48901Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 0C10.4288 0 7.91542 0.762436 5.77758 2.19089C3.63975 3.61935 1.97352 5.64966 0.989573 8.02511C0.00562997 10.4005 -0.251809 13.0144 0.249796 15.5362C0.7514 18.0579 1.98953 20.3742 3.80762 22.1924C5.62569 24.0105 7.94207 25.2486 10.4638 25.7502C12.9856 26.2518 15.5995 25.9944 17.9748 25.0104C20.3503 24.0264 22.3806 22.3602 23.8091 20.2224C25.2375 18.0845 26 15.5711 26 13C26 11.2928 25.6637 9.60233 25.0104 8.02511C24.3572 6.44788 23.3996 5.01477 22.1924 3.8076C20.9852 2.60045 19.5521 1.64287 17.9748 0.989559C16.3977 0.336258 14.7071 0 13 0ZM16.315 19.5L15.366 16.406H10.634L9.68499 19.5H6.72099L11.31 6.49999H14.677L19.279 19.5H16.315Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighschool);
export default __webpack_public_path__ + "static/media/highschool.1a6313d65781b54c36786b173bb613e5.svg";
export { ForwardRef as ReactComponent };